import BaseAnalysisService from './BaseAnalysisService';
import env from 'environment';

class XbrlAnalysisService
    extends BaseAnalysisService {
  constructor() {
    super({
      analysisType: 'xbrl',
      requireAnalysisTypeId: true,
    });
  }

  loadUserInput({ analysisId, tempId }) {
    if (!analysisId) {
      throw Error('Missing parameter: analysisId');
    }
    if (!tempId) {
      throw Error('Missing parameter: tempId');
    }

    let url = `${this.baseUrl}/${analysisId}/${this.analysisType}/${tempId}/input`;

    return this.get({
      url
    });
  }

  getFinancialStatements({ analysisId, tempId, data }) {
    if (!analysisId) {
      throw Error('Missing parameter: analysisId');
    }
    if (!tempId) {
      throw Error('Missing parameter: tempId');
    }
    if (!data) {
      throw Error('Missing parameter: data');
    }

    return this.post({
      url: `${this.baseUrl}/${analysisId}/${this.analysisType}/${tempId}/financial-statements`,
      data
    });
  }
}

const service = new XbrlAnalysisService();

export default service;
